<template>
  <div
    class="pointer-events-auto absolute inset-0 z-10 flex cursor-wait items-center justify-around bg-background-fg/5"
  >
    <IconLoading
      class="size-6 animate-spin text-primary"
      :class="spinnerClass"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  spinnerClass: {
    type: String,
    default: "",
  },
})
</script>
